<template>
  <v-app class="app-background">
    <!-- Top Bar -->
    <v-app-bar app elevation="0" class="glass-header blur-effect">
      <v-app-bar-nav-icon @click="drawer = !drawer" color="primary" />

      <v-spacer></v-spacer>

      <v-col cols="6" sm="5" md="4" lg="3" class="py-0">
        <v-select menu-props="auto" label="Compañía" hide-details prepend-inner-icon="mdi-city" single-line
          item-text="ciaNombre" item-value="ciaId" v-model="cia" :items="companies" @change="changeComapny"
          class="modern-input compact-select" outlined dense rounded></v-select>
      </v-col>

      <v-chip outlined color="primary" class="font-weight-bold px-3 px-md-4 mx-2" style="border-width: 2px;">
        <v-icon left>mdi-account-circle</v-icon>
        <span class="d-none d-sm-inline">{{ user.nombre }}</span>
      </v-chip>

      <v-btn to="/" icon color="error" class="glass-btn-error ml-1 ml-md-2" title="Cerrar Sesión">
        <v-icon>mdi-logout-variant</v-icon>
      </v-btn>
    </v-app-bar>

    <!-- Side Navigation -->
    <v-navigation-drawer app fixed v-model="drawer" floating class="glass-drawer blur-effect" width="280">
      <v-list-item class="px-3 py-4">
        <v-list-item-icon class="align-self-center mr-3" contain>
          <img height="50" src="../assets/logo3.png" alt="BestOne Logo" class="logo-glow" />
        </v-list-item-icon>

        <v-list-item-content>
          <v-list-item-title class="text-h6 font-weight-black primary--text">Lottery BestOne</v-list-item-title>
        </v-list-item-content>
      </v-list-item>

      <v-divider class="mb-2 mx-4 opacity-20"></v-divider>

      <v-list nav dense shaped class="drawer-list px-2">
        <v-list-item-group v-model="selectedItem" color="primary">
          <v-list-item link :to="inicio.path" :replace="replace" class="font-weight-medium">
            <v-list-item-icon>
              <v-icon>{{ inicio.icono }}</v-icon>
            </v-list-item-icon>
            <v-list-item-content>
              <v-list-item-title>
                {{ inicio.titulo }}
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>

          <div v-for="item in items" :key="item.menu">
            <v-list-item link :to="item.path" :replace="replace" v-if="!item.menuOpciones" class="font-weight-medium">
              <v-list-item-icon>
                <v-icon>{{ item.icono }}</v-icon>
              </v-list-item-icon>
              <v-list-item-content>
                <v-list-item-title>
                  {{ item.titulo }}
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>

            <v-list-group sub-group no-action :prepend-icon="item.icono" class="subItem font-weight-medium" v-if="item.menuOpciones">
              <template v-slot:activator>
                <v-list-item-title> {{ item.titulo }} </v-list-item-title>
              </template>

              <v-list-item v-for="subItem in item.menuOpciones" :key="subItem.titulo" link :to="subItem.path"
                :replace="replace" class="font-weight-medium">
                <v-list-item-icon>
                  <v-icon>{{ subItem.icono }}</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <v-list-item-title>
                    {{ subItem.titulo }}
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-group>
          </div>
        </v-list-item-group>

        <v-spacer class="my-4"></v-spacer>
        <v-divider class="mx-4 mb-4 opacity-20"></v-divider>

        <v-list-item justify-end class="px-4">
          <v-switch v-model="$vuetify.theme.dark" inset label="Modo oscuro" color="primary" hide-details class="mt-0"></v-switch>
        </v-list-item>

        <v-card-text v-if="!cedulas.includes(String(cia))" class="pb-0 pt-4">
          <span @click="openDialogDescargo" style="cursor: pointer;">
            <v-icon color="error" small class="mr-1">mdi-alert-octagram</v-icon>
          </span>
          <strong @click="openDialogDescargo" style="cursor: pointer;" class="text-caption text-uppercase letter-spacing-1">Descargo responsabilidad</strong>
        </v-card-text>
        
        <v-card-text class="py-2">
          <a href="https://www.youtube.com/@BestOneSolutions" target="_blank" rel="noopener noreferrer"
            style="cursor: pointer; color: inherit; text-decoration: none;" class="d-flex align-center">
            <v-icon color="error" class="mr-2">mdi-youtube</v-icon>
            <span class="font-weight-bold text-caption text-uppercase letter-spacing-1">Tutoriales</span>
          </a>
        </v-card-text>

        <v-card-text class="pt-0">
          <span @click="openDialog" style="cursor: pointer;" class="text-caption text-grey mr-1">{{ new Date().getFullYear() }}</span> —
          <strong @click="openDialog" style="cursor: pointer;" class="text-caption ml-1 font-weight-black">BestOne Solutions</strong>
        </v-card-text>
      </v-list>
    </v-navigation-drawer>

    <!-- Main Content Area -->
    <v-main class="ma-2 ma-md-4 ma-lg-6 main-wrapper">
      <transition name="fade-transform" mode="out-in">
        <router-view></router-view>
      </transition>
    </v-main>

    <!-- Dialogs -->
    <v-dialog v-model="dialog" persistent max-width="500">
      <v-card class="theme-aware-dialog rounded-xl">
        <v-card-title class="text-h6 font-weight-bold pt-6 text-center" style="word-break: break-word;">
          ¿Está seguro que quiere cambiar de compañía?
        </v-card-title>
        <v-card-text class="text-center pt-2 pb-0">
          Si presiona aceptar perderá todos los datos que no hayan sido guardados.
        </v-card-text>
        <v-card-actions class="pa-6 justify-center">
          <v-btn color="grey darken-1" text class="rounded-pill px-6" @click="cancelar()">Cancelar</v-btn>
          <v-btn color="error" class="rounded-pill px-8 font-weight-bold shadow-soft" @click="aceptar()">Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogInfo" max-width="500">
      <v-card class="theme-aware-dialog rounded-xl">
        <v-toolbar color="error" dark flat height="56">
          <v-icon class="mr-2">mdi-information-outline</v-icon>
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">Aviso Legal</v-toolbar-title>
        </v-toolbar>
        <v-card-text class="pa-6 text-body-1">
          <p class="mb-4"><strong>BestOne Solutions</strong> es una empresa de desarrollo de herramientas informáticas y soluciones a medida para nuestros clientes alrededor del mundo.</p>
          <p class="mb-0">BestOne Solutions no se hace responsable del uso que nuestros clientes y sus usuarios finales le den a las herramientas y/o software que hemos desarrollado bajo sus requerimientos.</p>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 justify-center">
          <v-btn color="grey darken-1" text class="rounded-pill px-6 font-weight-bold" @click="dialogInfo = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!-- Descargo de Responsabilidad Dialog -->
    <v-dialog v-model="dialogDescargo" max-width="800">
      <v-card class="theme-aware-dialog rounded-xl">
        <v-toolbar color="error" dark flat class="mb-2" height="56">
          <v-icon class="mr-2">mdi-alert-circle</v-icon>
          <v-toolbar-title class="text-subtitle-1 font-weight-bold">
            DESCARGO DE RESPONSABILIDAD
          </v-toolbar-title>
        </v-toolbar>
        
        <v-card-text class="pa-6 text-body-1" style="max-height: 60vh; overflow-y: auto;">
          <p class="mb-4">
            <strong>BestOne Solutions</strong> alquila un sistema de venta de tiempos con el propósito de facilitar las transacciones entre vendedores y banqueros. No obstante, al utilizar este sistema, el usuario reconoce y acepta los siguientes términos y condiciones:
          </p>
          <ol class="pl-4 mb-4" style="line-height: 1.6;">
            <li class="mb-2"><strong>Uso del Sistema:</strong> BestOne Solutions actúa únicamente como proveedor de la plataforma y no interviene en las transacciones realizadas entre las partes. Por lo tanto, no asumimos ninguna responsabilidad por el uso que se haga del sistema, incluyendo cualquier pérdida, fraude o disputa que pudiera surgir.</li>
            <li class="mb-2"><strong>Responsabilidad del Vendedor:</strong> Es exclusiva responsabilidad del vendedor verificar la confiabilidad de su banquero antes de realizar cualquier transacción. BestOne Solutions no se hace responsable por fondos retenidos, pagos no efectuados u otras incidencias derivadas de la relación entre vendedor y banquero.</li>
            <li class="mb-2"><strong>Responsabilidad del Banquero:</strong> Los banqueros deben operar con total transparencia e integridad. En caso de recibir reportes de estafa, fraude o prácticas indebidas, BestOne Solutions se reserva el derecho de deshabilitar de inmediato su acceso al sistema sin previo aviso ni derecho a reclamación.</li>
            <li class="mb-2"><strong>Reportes y Sanciones:</strong> Cualquier usuario que detecte una actividad fraudulenta deberá reportarla de inmediato a BestOne Solutions. Nos reservamos el derecho de investigar dichos reportes y tomar las medidas que consideremos necesarias, incluyendo la suspensión o eliminación de cuentas involucradas.</li>
            <li class="mb-2"><strong>Limitación de Responsabilidad:</strong> BestOne Solutions no será responsable por pérdidas económicas, daños directos o indirectos, ni por cualquier otra consecuencia derivada del uso del sistema. Al acceder y utilizar nuestra plataforma, el usuario acepta liberar a BestOne Solutions de cualquier reclamación o responsabilidad relacionada con transacciones realizadas en el sistema.</li>
          </ol>
          <p class="mb-4 text-center font-weight-bold">
            El uso de este sistema implica la aceptación total de los términos aquí descritos. BestOne Solutions se reserva el derecho de modificar este descargo de responsabilidad en cualquier momento sin previo aviso.
          </p>
          <v-alert dense outlined type="info" class="mb-0 text-center rounded-xl">
            Haga sus reportes al correo: <strong>soportebestone@gmail.com</strong>
          </v-alert>
        </v-card-text>
        
        <v-divider></v-divider>
        <v-card-actions class="pa-4 justify-center">
          <v-btn color="grey darken-1" text class="rounded-pill px-6 font-weight-bold" @click="dialogDescargo = false">Cerrar y Aceptar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="dialogLicencia" max-width="500">
      <v-card class="theme-aware-dialog rounded-xl">
        <v-card-title class="red--text text-h6 font-weight-bold pt-6 text-center">BestOne Solutions informa</v-card-title>
        <v-card-text class="text-center text-body-1 pa-6">
          {{ licenciaValida.motivo }}
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions class="pa-4 justify-center">
          <v-btn color="error" class="rounded-pill px-8 font-weight-bold shadow-soft" @click="dialogLicencia = false">Cerrar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <Snackbar v-bind:text="snackText" v-bind:snackbar.sync="snackValue" />
  </v-app>
</template>

<script>
import { mapMutations } from "vuex";
import { mapGetters } from "vuex";
import axios from "axios";
import Snackbar from "../components/shared/Snackbar.vue";

export default {
  components: {
    Snackbar,
  },
  data() {
    return {
      drawer: true,
      replace: true,
      selectedItem: "",
      cia: "",
      ciaOld: "",
      items: [],
      companies: [],
      licenciaValida: [],
      dialog: false,
      dialogInfo: false,
      dialogDescargo: false,
      dialogLicencia: false,
      cedulas: [
        "702310650",
        "304060113",
        "402050568",
        "112020837",
        "suertejj1",
        "suertejj2",
        "suertejj3",
        "602730144",
        "suertejj4",
        "208520034",
        "suertejj5",
        "suertejj6",
        "303650094",
        "402110078",
        "702220782",
        "luckysj2",
        "155832091900",
        "402260427",
        "109320696",
        "402080169",
        "pmevelyn",
        "pmdanilu",
        "pmtito",
        "pmmacha",
        "pmmickaely",
        "pmlopez"
      ],
      facebookLink: "",
      inicio: {
        titulo: "Inicio",
        icono: "mdi-view-dashboard",
        path: "/dashboard",
      },
    };
  },

  computed: {
    ...mapGetters(["user"]),
  },

  beforeMount() {
    window.addEventListener("beforeunload", this.preventNav);
    this.getModeloMenu();
    this.getCompanies();
    this.cia = this.user.ciaPorDefecto;
    this.ciaOld = this.user.ciaPorDefecto;
    this.validarLicencia();
  },

  beforeDestroy() {
    window.removeEventListener("beforeunload", this.preventNav);
  },

  methods: {
    ...mapMutations(["setStrCia"]),

    changeComapny() {
      this.dialog = true;
    },

    aceptar() {
      this.setStrCia(this.cia);
      this.ciaOld = this.cia;
      this.dialog = false;
      this.$router.replace({ name: "Dashboard" });
    },

    openDialog() {
      this.dialogInfo = true; // Abre el diálogo
    },

    openDialogDescargo() {
      this.dialogDescargo = true; // Abre el diálogo
    },

    closeDialog() {
      this.dialogInfo = false; // cierra el diálogo
    },

    cancelar() {
      this.cia = this.ciaOld;
      this.dialog = false;
    },

    getCompanies() {
      let me = this;
      me.setStrCia(this.user.ciaPorDefecto);
      axios
        .get("api/Usuarios/getCiasPorUsuario?usuarioId=" + this.user.id)
        .then(function (response) {
          me.companies = response.data;
          me.cia = this.user.ciaPorDefecto;
          me.ciaOld = this.user.ciaPorDefecto;
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    validarLicencia() {
      let me = this;
      axios
        .get("api/Usuarios/licenciaDiasRestantes?cia=" + this.cia)
        .then(function (response) {
          me.licenciaValida = response.data;
          if (!me.licenciaValida.valido) {
            me.dialogLicencia = true;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getModeloMenu() {
      let me = this;
      me.setStrCia(this.user.ciaPorDefecto);
      axios
        .get("api/Usuarios/getModeloMenu?usuarioId=" + this.user.id)
        .then(function (response) {
          me.items = response.data;
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    preventNav(event) {
      event.preventDefault();
    },
  },
};
</script>

<style>
/* Global Application Background */
.app-background {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%) !important;
  min-height: 100vh;
}

.theme--dark.app-background {
  background: linear-gradient(135deg, #1e1e2e 0%, #11111b 100%) !important;
}

/* Glassmorphism Classes */
.glass-header {
  background: rgba(255, 255, 255, 0.7) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.3) !important;
}

.theme--dark .glass-header {
  background: rgba(30, 30, 46, 0.8) !important;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1) !important;
}

.glass-drawer {
  background: rgba(255, 255, 255, 0.85) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.4) !important;
  box-shadow: 4px 0 24px rgba(0,0,0,0.04) !important;
}

.theme--dark .glass-drawer {
  background: rgba(30, 30, 46, 0.9) !important;
  border-right: 1px solid rgba(255, 255, 255, 0.1) !important;
  box-shadow: 4px 0 24px rgba(0,0,0,0.2) !important;
}

.blur-effect {
  backdrop-filter: blur(12px) !important;
  -webkit-backdrop-filter: blur(12px) !important;
}

/* Menu Typography and Active States */
.drawer-list .v-list-item--active {
  background: rgba(25, 118, 210, 0.1) !important;
  color: #1976D2 !important;
}

.drawer-list .v-list-item--active::before {
  opacity: 0 !important;
}

.theme--dark .drawer-list .v-list-item--active {
  background: rgba(255, 255, 255, 0.1) !important;
  color: #FFFFFF !important;
}

/* Controls */
.glass-btn-error {
  background: rgba(244, 67, 54, 0.1) !important;
  transition: all 0.2s ease;
}

.glass-btn-error:hover {
  background: rgba(244, 67, 54, 0.2) !important;
  transform: scale(1.05);
}

.header-controls {
  gap: 8px;
}

.compact-select {
  max-width: 250px;
}

.compact-select >>> .v-input__control > .v-input__slot {
  background: rgba(255, 255, 255, 0.5) !important;
  backdrop-filter: blur(4px);
}

.theme--dark .compact-select >>> .v-input__control > .v-input__slot {
  background: rgba(0, 0, 0, 0.2) !important;
}

/* Logo and Effects */
.logo-glow {
  filter: drop-shadow(0 4px 6px rgba(0,0,0,0.1));
}

.theme--dark .logo-glow {
  filter: drop-shadow(0 4px 8px rgba(255,255,255,0.1));
}

.letter-spacing-1 {
  letter-spacing: 1px;
}

.shadow-soft {
  box-shadow: 0 4px 20px rgba(0,0,0,0.08) !important;
}

/* Theme Aware Dialog/Card */
.theme-aware-dialog {
  border-radius: 24px !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  background: rgba(255, 255, 255, 0.95) !important;
  backdrop-filter: blur(20px) !important;
}

.theme--dark .theme-aware-dialog {
  background: rgba(30, 30, 46, 0.95) !important;
  border: 1px solid rgba(255, 255, 255, 0.05) !important;
}

.fade-transform-enter-active,
.fade-transform-leave-active {
  transition: all 0.3s ease;
}

.fade-transform-enter {
  opacity: 0;
  transform: translateX(-15px);
}

.fade-transform-leave-to {
  opacity: 0;
  transform: translateX(15px);
}

.main-wrapper {
  position: relative;
  z-index: 1;
}

.main {
  max-height: 100%;
  max-width: 100%;
}

/* Custom Scrollbar */
::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background: rgba(150, 150, 150, 0.3);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(150, 150, 150, 0.5);
}
</style>